/// <reference path="../tools/SoundItem.ts" />
/// <reference path="../tools/VibrateItem.ts" />

namespace SP.Sounds {
    export let Error = new SP.SoundItem('/sound/error.wav', 1, 200);
    export let Success = new SP.SoundItem('/sound/success.wav');
    export let Notification = new SP.SoundItem('/sound/notification.wav', 1, 200);
    export let Click = new SP.SoundItem('/sound/click.wav', 0.1, 25);
    export let Vibrate = new SP.VibrateItem();


}

